const MLP_KALENDER_URL = 'https://portal.mlpdialog.de/kfz/public/kalender';

// Property names are the portal's query parameters, which it matches against a fixed list.
export interface MlpCampaignPrefill {
  vorname?: string | null;
  nachname?: string | null;
  Kdnr?: string | null;
  kontaktweg?: string | null;
}

/**
 * Builds a link into the MLP callback calendar for a campaign.
 *
 * `cs` is the digit sum of the current date as `DDMMYYYY`. The campaign rejects links whose
 * checksum is missing or wrong (it redirects to a dummy page), which keeps static links from
 * being spread via search engines or Berater. The previous and next day are also accepted.
 */
export function buildMlpCampaignUrl(
  campaignId: string,
  prefill: MlpCampaignPrefill = {},
  date = new Date()
): string {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  const checksum = `${day}${month}${year}`.split('').reduce((sum, digit) => sum + Number(digit), 0);

  const query = new URLSearchParams({ CampaignID: campaignId, cs: checksum.toString() });
  for (const [key, value] of Object.entries(prefill)) {
    const trimmed = value?.trim();
    if (trimmed) {
      query.set(key, trimmed);
    }
  }

  // URLSearchParams spells a space `+`, which only a form decoder reads back as a space.
  return `${MLP_KALENDER_URL}?${query.toString().replace(/\+/g, '%20')}`;
}
